<template>
    <div class="plot-contrast-table">
        <div class="header clearfix">
            <div class="left">
                <span class="go-back" @click="goBack()">
                    <i class="iconfont icon-fanhui"></i>
                    <span>返回</span>
                </span>
                <span class="name">地块对比</span>
            </div>
            <div class="operation right">
                <span @click="contraction()">
                    <i :class="plotTableExpand ? 'iconfont icon-quanping' : 'iconfont icon-shouqi'"></i>
                </span>
                <span @click="close()">
                    <i class="iconfont icon-guanbi"></i>
                </span>
            </div>
        </div>
        <div class="plot" v-show="!plotTableExpand">
            <div class="plot-table">
                <div class="table-header">
                    <table>
                        <tr>
                            <td style="width: 10%;">地块名称</td>
                            <td :style="'width: calc((100% - 10%) / '+plotTable.length+');'" v-for="(item, index) in plotTable" :key="'header'+ index" >
                                <div v-html="item.dkmc"></div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="table-body">
                    <el-scrollbar style="width: 100%;height: 100%;">
                        <div class="body-content">
                            <table>
                                <tr>
                                    <td style="width: 10%;">全景图</td>
                                    <td :style="'width: calc((100% - 10%) / '+plotTable.length+');'" v-for="(item, index) in plotTable" :key="'img'+ index" >
                                        <div class="table-img">
                                            <photosphereviewer :landinfo ="item" ></photosphereviewer>
                                        </div>
                                    </td>
                                </tr>
                                 <tr>
                                    <td>推介说明</td>
                                    <td v-for="(item, index) in plotTable" :key="'TJSM'+ index" >
                                        <div v-html="item.tjsm"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>地块位置</td>
                                    <td v-for="(item, index) in plotTable" :key="'DKWZ'+ index" >
                                        <div v-html="item.dkdz"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>行政区</td>
                                    <td v-for="(item, index) in plotTable" :key="'XZQ'+ index" >
                                        <div v-html="item.xzqmc"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>地块面积</td>
                                    <td v-for="(item, index) in plotTable" :key="'DKMJ'+ index" >
                                        <div v-html="item.dkmj"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>容积率</td>
                                    <td v-for="(item, index) in plotTable" :key="'RJL'+ index" >
                                        <div v-html="item.rjl"></div>
                                    </td>
                                </tr>
                                 <tr>
                                    <td>绿化率</td>
                                    <td v-for="(item, index) in plotTable" :key="'RJL'+ index" >
                                        <div v-html="item.lhl"></div>
                                    </td>
                                </tr>
                                 <tr>
                                    <td>建筑密度</td>
                                    <td v-for="(item, index) in plotTable" :key="'RJL'+ index" >
                                        <div v-html="item.jzmd"></div>
                                    </td>
                                </tr>
                                 <tr>
                                    <td>出让年限</td>
                                    <td v-for="(item, index) in plotTable" :key="'RJL'+ index" >
                                        <div v-html="item.crnx"></div>
                                    </td>
                                </tr>
                                 <tr>
                                    <td>建筑限高</td>
                                    <td v-for="(item, index) in plotTable" :key="'RJL'+ index" >
                                        <div v-html="item.jzxg"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>土地用途</td>
                                    <td v-for="(item, index) in plotTable" :key="'NGDFS'+ index" >
                                        <div v-html="item.tdyt"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>开发程度</td>
                                    <td v-for="(item, index) in plotTable" :key="'NGDSJ'+ index" >
                                        <div v-html="item.kfcd"></div>
                                    </td>
                                </tr>
                                   <tr>
                                    <td>规划社区配套</td>
                                    <td v-for="(item, index) in plotTable" :key="'NGDSJ'+ index" >
                                        <div v-html="item.sqpt"></div>
                                    </td>
                                </tr>
                                  <tr>
                                    <td>规划教育配套</td>
                                    <td v-for="(item, index) in plotTable" :key="'NGDSJ'+ index" >
                                        <div v-html="item.jypt"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>规划养老配套</td>
                                    <td v-for="(item, index) in plotTable" :key="'NGDSJ'+ index" >
                                        <div v-html="item.ylpt"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>其他</td>
                                    <td v-for="(item, index) in plotTable" :key="'NGDSJ'+ index" >
                                        <div v-html="item.qt"></div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import photosphereviewer from 'components/main-map/photosphereviewer'
export default {
  components: {photosphereviewer},
  data() {
    return {
      plotTableExpand: false,
      plotTable: []
    }
  },
  methods: {
    // 开始对比
    contrast(data) {
      this.plotTable = data
    },
    // 扩大缩小
    contraction() {
      this.plotTableExpand = !this.plotTableExpand
    },
    // 关闭
    close() {
      this.$parent.plotContrastTableShow = false
    },
    goBack() {
      this.$parent.plotContrastTableShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
    .plot-contrast-table{
        position: fixed;
        width: calc(100% - 530px);
        background: #ffffff;
        border-radius: 4px;
        box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.25);
        right: 10px;
        top: 80px;
        .header{
            height: 44px;
            padding: 10px;
            border-bottom: 1px solid #dedede;
            .go-back{
                height: 24px;
                background: #4293f4;
                border-radius: 4px;
                color: #ffffff;
                cursor: pointer;
                line-height: 24px;
                padding: 0px 8px;
                display: inline-block;
                margin-right: 10px;
                i.iconfont{
                    font-size: 14px;
                }
            }
            .name{
                font-size: 16px;
                font-weight: bold;
                color: #333333;
                vertical-align: middle;
            }
            .operation{
                line-height: 24px;
                i.iconfont{
                    font-size: 14px;
                    margin-left: 10px;
                    cursor: pointer;
                }
            }
        }
        .plot{
            height: calc(100vh - 185px);
            padding: 20px 0px;
            width: 100%;
            .plot-table{
                height: 100%;
                width: 100%;
                .table-header{
                    padding:0px 10px;
                    table{
                        width: 100%;
                        border-collapse:collapse;
                        border-spacing:0;
                        td{
                            border: 1px solid #e5e9eb;
                            background: #f1f4f8;
                            border-bottom: none;
                            font-size: 16px;
                            font-weight: bold;
                            color: #333;
                            padding:14px 10px;
                            &:first-child{
                                font-size: 16px;
                                font-weight: normal;
                                color: #999999;
                            }
                        }
                    }
                }
                .table-body{
                    height: calc(100% - 42px);
                    .body-content{
                        padding: 0px 10px;
                        table{
                            width: 100%;
                            border-collapse:collapse;
                            border-spacing:0;
                            tr{
                                &:nth-child(odd){
                                    td{
                                        background: #fff;
                                    }
                                }
                                &:nth-child(even){
                                    td{
                                        background: #f1f4f8;
                                    }
                                }
                                &:first-child{
                                    td{
                                        padding: 0px;
                                    }
                                }
                                &:last-child{
                                    td{
                                        text-align: left;
                                        &:first-child{
                                            text-align: center;
                                        }
                                    }
                                }
                            }
                            td{
                                border: 1px solid #e5e9eb;
                                background: #f1f4f8;
                                font-size: 16px;
                                font-weight: normal;
                                color: #333;
                                padding:14px 10px;
                                &:first-child{
                                    font-size: 16px;
                                    font-weight: normal;
                                    color: #999999;
                                }
                                .table-img{
                                    height: 197px;
                                    width: 100%;
                                    img{
                                        width: 100%;
                                        height: 100%;
                                    }
                                }
                            }
                        }
                    }
                    ::v-deep{
                        .el-scrollbar__wrap{
                            overflow-x: hidden;
                        }
                    }
                }
            }
        }
    }
</style>
